/**
 * SocialMediaThresholdService
 * Service for SocialMediaThreshold entity operations
 * Route: api/socialmedia/thresholds
 */
import { CrudService } from '../base/CrudService';
/**
 * SocialMediaThresholdService
 * Handles social media threshold CRUD operations
 */
export class SocialMediaThresholdService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SocialMediaThresholdService.DEFAULT_SERVICE_PATH,
            basePath: SocialMediaThresholdService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET ALL ACTIVE ====================
    /**
     * Get all active thresholds
     * GET api/socialmedia/thresholds
     */
    async getAllActive() {
        const response = await this.getAllActiveRaw();
        return response.data ?? [];
    }
    /**
     * Get all active thresholds with full response
     */
    getAllActiveRaw() {
        const endpoint = this.getEndpoint('list', '');
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== GET BY ACCOUNT ====================
    /**
     * Get thresholds by account ID
     * GET api/socialmedia/thresholds/account/{accountId}
     */
    async getByAccount(accountId) {
        const response = await this.getByAccountRaw(accountId);
        return response.data ?? [];
    }
    /**
     * Get thresholds by account ID with full response
     */
    getByAccountRaw(accountId) {
        const endpoint = this.getEndpoint('by-account', `account/${accountId}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== CHECK THRESHOLD ====================
    /**
     * Check threshold against current value
     * POST api/socialmedia/thresholds/{id}/check?currentValue={currentValue}
     */
    async checkThreshold(id, currentValue) {
        const response = await this.checkThresholdRaw(id, currentValue);
        if (!response.success) {
            throw new Error(response.message || 'Failed to check threshold');
        }
    }
    /**
     * Check threshold with full response
     */
    checkThresholdRaw(id, currentValue) {
        const endpoint = this.getEndpoint('check', `${id}/check`);
        const url = this.buildUrl(endpoint);
        return this.http.post(`${url}?currentValue=${currentValue}`);
    }
}
SocialMediaThresholdService.DEFAULT_SERVICE_PATH = 'socialmedia';
SocialMediaThresholdService.BASE_PATH = 'api/socialmedia/thresholds';
//# sourceMappingURL=SocialMediaThresholdService.js.map